const xenaToFmaForumule = {'M2':'F1','M3':'F2','M4':'F3','M7':'F4'}
const xenaToFmaOptions = {'IP1':'GIP1*','IP2':'GIP2*','AC1':'ACC1*','AC2':'ACC3*','AST':'ASS3*'}


function stripHtml(htmlString) {
  if (!htmlString) return '';
  
  return htmlString
    // Remove HTML tags
    .replace(/<[^>]*>/g, ' ')
    // Decode common HTML entities manually if needed
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"');
}

export default class DataFma {

    constructor(fma,devis) {
        for ( const key in fma ) {
            this[key] = fma[key]
        }
        this.devis = devis
        this.formule = false
        this.fractionnement = false
        this.selectedOptions = devis.getValue('selectedOptions',[])
        this.outputFancy = false 
        this.fancyDeflt = '-'
        this.fancyPost = '  €'
        this.deprecated = false
    }

    setDeprecated(parent) { 
        this.deprecated = parent
        return this
    }

    getCleanError() {
        // Returns this.error if "clean" or a cleaned-up user-readable version

        if ( this.calculating ) return 'En cours de calcul ...'
        if ( !this.error ) return ''
        if ( this.error.match( /Call log|Timeout|Locator/ ) ) return 'Tarification impossible'
        if ( this.error === 'logout' ) return 'Serveur temporairement indisponible'
        return this.error
    }

    prevFma() {
        // Loads up "previous" axa from devis into a new DataAxa object
        return new DataFma( this.devis.prev_fma || {}, this.devis ).setDeprecated(this).setChoicesFromDevis()
    }

    setFancy(deflt,post) {
        this.fancyDeflt = deflt
        this.fancyPost = post
        return this
    }

    fancyPrice(price) {
        const fprice = parseFloat(price)
        if ( !fprice ) return this.fancyDeflt
        const pm = DataFma.priceFormatter.format( fprice ).match(DataFma.regPrice)
        return pm ? <>{pm[1]}<sup>{pm[2]}</sup>{this.fancyPost}</> : fprice
    }

    swithToDeprecatedOnError() {
        return (( !this.hasFma() )&&( this.hasValidPrevFma() ))? this.prevFma() : this
    }

    hasValidPrevFma() {
        const { prev_fma } = this.devis
        return prev_fma && prev_fma.offres && !prev_fma.error
    }

    setChoicesFromDevis() {
        this.formule = xenaToFmaForumule[this.devis.getValue('formule')]
        this.fractionnement = this.devis.getValue('periodicite')
        return this
    }

    setFormuleFromXena(xena) {
        this.formule = xenaToFmaForumule[xena]
        return this
    }

    setFractionnement(fract) {
        this.fractionnement = fract
        return this
    }

    hasFma() {
        return ( this.offres && typeof this.offres === 'object' )&&( !this.error )
    }

    getOption( codeGarantie, formule ) {
        const offre = this.offre(formule)
        return offre?.options?.find( o => o.codeGarantie == codeGarantie )
    }

    getIncludedOption( codeGarantie, formule ) {
        const offre = this.offre(formule)
        return offre?.included?.find( o => o.codeGarantie == codeGarantie )
    }

    hasTarifs( formule ) {
        return !! this.offre( formule )
    }

    offre( formule ) {
        const f = formule ? xenaToFmaForumule[formule] : this.formule
        return this.offres && this.offres?.find( _f => _f.codeFormule == f )
    }

    hasOption( xenaCode, formule, fractionnement ) {
        if ( !fractionnement ) fractionnement = this.fractionnement
        const offre = this.offre( formule )
        if ( !( offre && offre.options ) ) return false
        const code = xenaToFmaOptions[xenaCode]
        if ( !code ) return false
        const option = offre.options.find( o => o.codeGarantie == code )
        return !! option
    }

    priceOptions( formule, fractionnement ) {
        if ( !fractionnement ) fractionnement = this.fractionnement
        const offre = this.offre( formule )
        if ( !( offre && offre.options ) ) return 0
        let price = 0
        for ( const xenaCode of this.selectedOptions ) {
            const code = xenaToFmaOptions[xenaCode]
            if ( !code ) continue;
            const option = offre.options.find( o => o.codeGarantie == code )
            if ( !option ) continue;
            price += ( fractionnement=='A' ) ? option.prime_A : option.prime_M
        }
        return price
    }

    mensuelLisse( formule ) {
        const offre = this.offre( formule )
        if ( !offre ) return 0
        return offre.cotisationMensuelle + offre.comptantCotisationMensuelle/12 + this.priceOptions(formule,'M')
    }

    mensuel( formule, no_options = false ) {
        const offre = this.offre( formule )
        if ( !offre ) return 0
        return offre.cotisationMensuelle + ( no_options ? 0 : this.priceOptions(formule,'M') )
    }

    synthese( formule ) {
        const offre = this.offre( formule )
        if ( !offre ) return 0
        return offre.synthese
    }

    comptantMensuel( formule ) {
        const offre = this.offre( formule )
        if ( !offre ) return 0
        return offre.comptantCotisationMensuelle + 2*this.priceOptions(formule,'M')
    }

    fraisCB() {
        return this.frais
    }

    coutTotal( formule, fractionnement ) {
        if ( ! fractionnement ) fractionnement = this.fractionnement
        return ( fractionnement == 'M' )? this.fraisCB() + this.comptantMensuel( formule )+this.mensuel( formule )*10 : this.annuel( formule )
    }

    comptant( formule, fractionnement ) {
        if ( ! fractionnement ) fractionnement = this.fractionnement
        return ( fractionnement == 'M' )? this.fraisCB() + this.comptantMensuel( formule ) : this.annuel( formule )
    }

    annuel( formule, no_options = false ) {
        const offre = this.offre( formule )
        if ( !offre ) return 0
        return offre.comptantCotisationAnnuelle+this.fraisCB() + ( no_options ? 0 : this.priceOptions(formule,'A') )
    }

    echeance( formule, fractionnement, no_options=false ) {
        if ( ! fractionnement ) fractionnement = this.fractionnement
        return ( fractionnement == 'M' )? this.mensuel( formule, no_options ) : this.annuel( formule, no_options ) 
    }

    display( formule ) {
        const offre = this.offre( formule )
        if ( !offre ) return ''
        return offre.synthese
    }

    explain( formule ) {
        const offre = this.offre( formule )
        if ( !offre ) return ''
        return offre.garanties

    }

    displayOptionDescription( xenaCode ) {
        const code = xenaToFmaOptions[xenaCode]
        return stripHtml(this.getOption(code)?.description||this.getIncludedOption(code)?.description)
    }

    description( formule ) {
        const offre = this.offre( formule )
        if ( !offre ) return 'Indisponible'
        if ( !offre.defaultFranchises ) return <><h3>Détails de l'offre Assur Discount</h3>{offre.garanties}</>
        return <><h3>Détails de l'offre Assur Discount</h3>{offre.garanties}<ul>{offre.defaultFranchises.map((franchise,idx)=><li key={idx}>{franchise.description}</li>)}</ul></>
    }

}

DataFma.regPrice = /^([\s0-9]+)(,[0-9]+)$/
DataFma.priceFormatter = new Intl.NumberFormat('fr-FR',{
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

DataFma.xenaOptionCodeToTitle = {
    'IP1':'Assurance individuelle pilote niveau 1',
    'IP2':'Assurance individuelle pilote niveau 2',
    'AC1':'Assurance accessoires niveau 1',
    'AC2':'Assurance accessoires niveau 2'
}